/* eslint-disable check-cross-package-imports/dont-import-redux-in-next */
import {
	updateContentProperty,
	editorPage,
	publishEditorPage,
	syncEditorDraft,
	publishEditorPageFromTemplate,
	createPage as createPageRestApi,
	draftMetadata,
	cancelScheduledPublish,
} from '@confluence-classic/confluence-rest-api-client';
import {
	content,
	commonActionCreator,
	restActionCreator,
} from '@confluence-classic/confluence-legacy-redux';

import {
	CHANGE_EDITOR_MODE,
	CHANGE_EDITOR_TITLE,
	CLOSE_EDITOR_ERROR,
	EDITOR_CONTENT,
	EDITOR_CONTENT_PUBLISH,
	EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH,
	RESET_EDITOR_STATE,
	EDITOR_CREATE_PAGE,
	EDITOR_DRAFT_SAVE,
	EDITOR_LOAD_COMPLETE,
	EDITOR_LOAD_DRAFT,
	EDITOR_LOAD_DRAFTMETADATA,
	EDITOR_PRELOAD_FINISH,
	EDITOR_PRELOAD_START,
	SET_SAVE_DRAFT,
	SHOW_EDITOR_ERROR,
	SET_IS_PUBLISHING_CONTENT,
	EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY,
	UPDATE_CONTENT_SPACE_KEY,
	EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG,
	EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT,
	EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE,
	EDITOR_CANCEL_SCHEDULED_PUBLISH,
	SET_IS_SCHEDULING_PUBLISH,
	EDITOR_CONTENT_EDITABLE,
} from './legacy-editor-action-types';

export { hideEditor } from './legacy-editor-common';

/**
 * Editor common actions
 *
 * Action requires:
 * {string} contentId - contentID editor related to
 * {string} mode - editor mode:
 *                 'addComment' - Add comment to the root of the page
 *                 'replyComment' - reply some comment (width defined `contentId`)
 *                 'editComment' - edit comment (with defined `contentId`)
 * {string} depthLevel - depth level for edit/reply comments;
 */
export const changeEditorMode = commonActionCreator(CHANGE_EDITOR_MODE);
export const changeEditorTitle = commonActionCreator(CHANGE_EDITOR_TITLE);
export const closeEditorError = commonActionCreator(CLOSE_EDITOR_ERROR);
export const showEditorError = commonActionCreator(SHOW_EDITOR_ERROR);
export const onEditorLoadComplete = commonActionCreator(EDITOR_LOAD_COMPLETE);
export const onStartPreloadEditor = commonActionCreator(EDITOR_PRELOAD_START);
export const onPreloadEditorFinish = commonActionCreator(EDITOR_PRELOAD_FINISH);
export const resetEditorContent = commonActionCreator(RESET_EDITOR_STATE);
export const onEditorContentEditable = commonActionCreator(EDITOR_CONTENT_EDITABLE);
export const updateContentAppearancePropertyFromCollab = commonActionCreator(
	`${EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY}_SUCCESS`,
);
export const updateContentAppearanceProperty = restActionCreator(
	EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY,
	updateContentProperty,
);
export const getEditorContent = restActionCreator(EDITOR_CONTENT, editorPage, {
	schema: content,
});
export const publishEditorContent = restActionCreator(EDITOR_CONTENT_PUBLISH, publishEditorPage, {
	schema: content,
});
export const publishEditorContentFromTemplate = restActionCreator(
	EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH,
	publishEditorPageFromTemplate,
	{ schema: content },
);

// Editor Drafts
export const saveEditorDraftContent = restActionCreator(EDITOR_DRAFT_SAVE, syncEditorDraft);
export const setSavingDraft = commonActionCreator(SET_SAVE_DRAFT);

export const setIsPublishingContent = commonActionCreator(SET_IS_PUBLISHING_CONTENT);

// Create page/blog draft
export const createPage = restActionCreator(EDITOR_CREATE_PAGE, createPageRestApi, {
	schema: content,
});

// Fetch draft data
export const getDraft = restActionCreator(EDITOR_LOAD_DRAFT, editorPage, {
	schema: content,
});

// Fetch metadata for the draft - e.g. spaceKey
export const getDraftMetadata = restActionCreator(EDITOR_LOAD_DRAFTMETADATA, draftMetadata, {
	schema: content,
});

// Change the true space key loaded by the content query
// ... we need to do this if the page was moved to another space
export const updateContentSpaceKey = commonActionCreator(UPDATE_CONTENT_SPACE_KEY);

// Scheduled publish required actions
export const showScheduledPublishDialog = commonActionCreator(EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG);
export const hideScheduledPublishComponent = commonActionCreator(
	EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT,
);
export const setCurrentlyScheduledPublishDate = commonActionCreator(
	EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE,
);
export const setIsSchedulingPublish = commonActionCreator(SET_IS_SCHEDULING_PUBLISH);
export const cancelEditorScheduledPublish = restActionCreator(
	EDITOR_CANCEL_SCHEDULED_PUBLISH,
	cancelScheduledPublish,
);
